import React, { useState, useEffect } from 'react';
import './Center.css';
import { useNavigate } from 'react-router-dom';
import { areas } from './areas';
import locationIcon from '../Image/google-maps.png';
import direction from '../Image/location.png'
import { initFacebookPixel } from '../facebookPixel';
const Center = () => {
  const [selectedCenter, setSelectedCenter] = useState("");
  const [centers, setCenters] = useState([]);
  const [currentImageIndices, setCurrentImageIndices] = useState({});
  const [error, setError] = useState(null);

  const handleChange = (event) => {
    setSelectedCenter(event.target.value);
  };
  useEffect(() => {
    initFacebookPixel(); // Initialize Facebook Pixel on app load
  }, []);
  const fetchSportsCenters = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL_PURCHASE; // Get API URL from the environment variable
      const apiKey = process.env.REACT_APP_API_KEY; 
      const response = await fetch(apiUrl, {
        headers: {
          'x-api-key':apiKey,
        }
      });
      if (!response.ok) {
        throw new Error('Failed to fetch sports centers data.');
      }
      const data = await response.json();
      const academyImages = data.academyImages || {};

      const defaultImages = [
        "https://machaxiprod.blob.core.windows.net/frontend-machaxi/learn-images/learn2.webp",
        "https://machaxiprod.blob.core.windows.net/dribble-images/1650874195674_WhatsApp%20Image%202022-04-18%20at%205.49.40%20PM.jpeg",
        "https://machaxiprod.blob.core.windows.net/dribble-images/1727034283075_MSC%20-%2021.webp"
      ];

      const centersData = data.sportsToAcademiesMap.Swimming.map(center => {
        const academyId = center?.id;
        const sports = data.academiesToSportsMap[academyId] || [];
        const images = academyImages[academyId] || defaultImages;

        const areaCenter = areas.flatMap(area => area.centers).find(ac => ac.id === academyId);
        const locationUrl = areaCenter ? areaCenter.location : '#';

        return {
          id: academyId || [],
          name: center?.name || 'Unknown Center',
          sports: sports.map(sport => sport.sport_name) || [],
          images: images,
          locationUrl: locationUrl,
        };
      });

      setCenters(centersData);
      const initialIndices = {};
      centersData.forEach(center => {
        initialIndices[center.id] = 0;
      });
      setCurrentImageIndices(initialIndices);
      setError(null);
    } catch (error) {
      setError('Failed to load sports centers data. Please try again later.');
    }
  };

  useEffect(() => {
    fetchSportsCenters();
  }, []);

  const selectedAreaDetails = areas.find(area => area.name === selectedCenter);

  const filteredCenters = selectedCenter && selectedAreaDetails
    ? centers.filter(center => {
      if (!selectedAreaDetails.centers) {
        return false;
      }
      return selectedAreaDetails.centers.some(area => area.id === center.id);
    })
    : centers;

  const cycleImage = (centerId) => {
    setCurrentImageIndices(prevIndices => {
      const currentIndex = prevIndices[centerId];
      const center = centers.find(c => c.id === centerId);
      const nextIndex = (currentIndex + 1) % center.images.length;
      return { ...prevIndices, [centerId]: nextIndex };
    });
  };

  useEffect(() => {
    const intervals = filteredCenters.map(center => {
      return setInterval(() => {
        cycleImage(center.id);
      }, 2000);
    });
    return () => intervals.forEach(interval => clearInterval(interval));
  }, [filteredCenters]);

  return (
    <div className="center-container">
      <h1 className="center-heading">Centres Near Me</h1>
      <label htmlFor="area-select" className="area-select-label">Select an area:</label>
      <select id="area-select" value={selectedCenter} onChange={handleChange} className="area-select">
        <option value="">--Please select an area--</option>
        {areas.map((area, index) => (
          <option key={index} value={area.name}>{area.name}</option>
        ))}
      </select>

      <div className="centers-list-container">
        {error ? (
          <p className="error-message">{error}</p>
        ) : (
          <div className="centers-details">
            {filteredCenters.length > 0 ? (
              filteredCenters.map((center, index) => (
                <div key={index} className="center-card">
                  <div className="image-container">
                    <img
                      src={center.images[currentImageIndices[center.id]]}
                      alt={`${center.name} ${currentImageIndices[center.id] + 1}`}
                      className="center-image"
                    />
                  </div>
                  <div className="info-container">
                    <div className="name-sports-container">
                      <h3 className="center-name">{center.name}</h3>
                      <div className="sports-list">
                        {center.sports.map((sport, idx) => (
                          <span key={idx} className="sports-item">{sport}</span>
                        ))}
                      </div>
                    </div>
                    <div className="button-container">
                      <a href={center.locationUrl} target="_blank" rel="noopener noreferrer">

                        <button className="get-directions-btn">
                          <img src={direction} alt="direction icon" className="direction-icon" />
                          Get Directions
                        </button>
                      </a>
                    </div>
                  </div>
                </div>


              ))
            ) : (
              <p>No centres available for the selected area.</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Center;
